import {AR_V2, CORE_AMZL, DOCK_DOOR, ROUTE_VIEW} from "./Constants";
import {isARorSSD, isNotINRegionOrSSD} from "./Util";

export const SIDELINED = "Sidelined";
export const ROUTE_CUT = "RouteCut";
export const ASSIGNABLE = "Assignable";
export const IN_PROGRESS = "In Progress";
export const STOW_IN_PROGRESS ="Stow in progress";
export const PICKED = "Picked";
export const MISSING = "Missing";
export const READY = "Ready";
export const NOT_READY = "Not Ready";
export const STAGED = "Staged";
export const PRE_STAGED = "Pre Staged"
export const NOT_STAGED = "Not Staged";
export const NOT_DEPARTED = "Not Departed";
export const NOT_ASSIGNED = "Not Assigned";
export const ASSIGNED = "Assigned";
export const STOWED = "Stowed";
export const DEPARTED = "Departed";
export const EXECUTING = "EXECUTING";
export const PLANNED = "PLANNED";
export const CANCELLED = "Cancelled";
export const ROUTE_CANCELLED = "Cancelled";
export const READY_FOR_DISPATCH = "READYFORDISPATCH";
export const DISPATCHED = "DISPATCHED";
export const PARTIALLY_DEPARTED = "Departed (partial)";
export const PARTIALLY_STAGED = "Staged (partial)";
export const INTERIM_STAGED = "Staged-Interim";
export const NOT_PICKED_STATUS_LIST = [NOT_READY, ASSIGNABLE, IN_PROGRESS];
export const MULTI_BOX = "MultiBox";
export const PDD = "PDD";
export const SCHEDULED_DELIVERY = "Scheduled Delivery";
export const CART_STATUS = {
    PRE_STAGED: PRE_STAGED,
    STAGED: STAGED,
    SIDELINED: SIDELINED
}
export const STAGE_STATUS = {
    NOT_READY: NOT_READY,
    READY: READY,
    PRE_STAGED: PRE_STAGED,
    STAGED: STAGED,
    PARTIALLY_STAGED: PARTIALLY_STAGED,
    SIDELINED: SIDELINED
}

export const STAGE_TASK_PLAN_STATUS = {
    ASSIGNABLE: "ASSIGNABLE",
    HOLD: "HOLD"
}

export const DEPART_STATUS = {
    NOT_READY: NOT_READY,
    READY: READY,
    DEPARTED: DEPARTED,
    PARTIALLY_DEPARTED: PARTIALLY_DEPARTED,
}

export const DEPART_STATUS_IN = {
    NOT_READY: NOT_READY,
    READY: READY,
    DEPARTED: DEPARTED,
    ROUTE_CANCELLED : ROUTE_CANCELLED
}

export const SHIPMENT_TYPE_AMXL = {
    SCHEDULED_DELIVERY: SCHEDULED_DELIVERY,
    PDD: PDD,
    MULTI_BOX: MULTI_BOX
}


/**
 * Returns route status
 *
 * @param rswsRoute status returned by RSWS
 * @param stationConfig station config 
 * @returns parsed status
 */
export function getRouteStatus(rswsRoute, stationConfig) {
    if (rswsRoute.sidelined) {
        return SIDELINED;
    } else if (rswsRoute.routeCut) {
        return ROUTE_CUT;
    } else if(isRouteInterimStaged(rswsRoute, stationConfig)) {
        return INTERIM_STAGED;
    }
    return rswsRoute.routeStatus;
}

/**
 * Checks if route is staged at dock door. Applicable only to SSD MMOT
 * @param route
 * @returns {boolean}
 */
function isRouteStagedAtDD(route) {
    let isRouteStaged = false;
    route.stagingLocations.forEach((stagingLocation) => {
        if (stagingLocation.locationType === DOCK_DOOR) {
            isRouteStaged = true;
        }
    });
    return isRouteStaged;
}

function isRouteInterimStaged(rswsRoute, stationConfig) {
    return stationConfig && stationConfig.ssdmmotenabled && rswsRoute.routeStatus === STAGED && !isRouteStagedAtDD(rswsRoute);
}

/**
 * Returns route status indicator color
 *
 * @param status of route
 * @returns color
 */
export function getRouteStatusColor(routeStatus) {
    switch (routeStatus) {
        case SIDELINED:
            return "error";
        case ROUTE_CUT:
            return "warning";
        case DEPARTED:
            return "success";
        case STAGED:
            return "success";
        case ASSIGNABLE:
            return "neutral";
        default:
            return "warning";
    }
}

function allCartsPreStaged(carts, route, capability, stationConfig) {
    return carts && carts.length && carts.every(cart => getCartStatus(route, cart, capability, stationConfig) === PRE_STAGED);
}

function allCartsStaged(carts, route, capability, stationConfig) {
    return carts && carts.length && carts.every(cart => getCartStatus(route, cart, capability, stationConfig) === STAGED);
}

/**
 * Returns stage status
 *
 * @param rswsRoute status returned by RSWS
 * @param stationConfig
 * @param capability
 * @returns stage status
 */
export function getStageStatus(rswsRoute, stationConfig, capability) {
    if (rswsRoute.sidelined) {
        return SIDELINED;
    }
    const isArOrSSD = isARorSSD(capability);
    switch (rswsRoute.routeStatus) {
        case DEPARTED:
        case PARTIALLY_DEPARTED:
        case PARTIALLY_STAGED:
        case STAGED:
            if (stationConfig.splitStagingEnabled) {
                if (allCartsPreStaged(rswsRoute.carts, rswsRoute, capability, stationConfig)) {
                    return STAGE_STATUS.PRE_STAGED;
                } else if (allCartsStaged(rswsRoute.carts, rswsRoute, capability, stationConfig)) {
                    return STAGE_STATUS.STAGED;
                }
            } else if (isRouteInterimStaged(rswsRoute, stationConfig)) {
                    return INTERIM_STAGED
            }
            return isPartiallyStaged(rswsRoute, stationConfig, capability) ? STAGE_STATUS.PARTIALLY_STAGED : STAGE_STATUS.STAGED;
        case ASSIGNABLE:
            if (isArOrSSD) {
                return STAGE_STATUS.READY;
            } else {
                return STAGE_STATUS.NOT_READY;
            }
        case IN_PROGRESS:
            if (isArOrSSD || (!stationConfig.pickStageDecoupleEnabled && isPickingComplete(rswsRoute))) {
                return STAGE_STATUS.READY;
            } else {
                return STAGE_STATUS.NOT_READY;
            }
        default:
            return rswsRoute.routeStatus;
    }
}

/**
 * Note: NOT applicable for ARv2.
 * Note: After stage-re-arch project, partial staging status for AMZL coupled sites is determined using pickProgressV2.
 * Note : For STAG, we are directly returning FALSE as we don't have item level progress available
 * TODO : For STAG, construct a solution to track item level progress
 * @param rswsRoute
 */
function isPartiallyStaged(rswsRoute, stationConfig, capability) {
    if(stationConfig.stagenabled) {
        return false
    }
    else if (stationConfig.pickStageDecoupleEnabled || isARorSSD(capability)) {
        return rswsRoute.stageProgress && rswsRoute.stageProgress.totalCount && (rswsRoute.stageProgress.completedCount < rswsRoute.stageProgress.totalCount);
    } else {
        return rswsRoute.pickProgressV2
            && rswsRoute.pickProgressV2.totalCount
            && (rswsRoute.pickProgressV2.completedCount < rswsRoute.pickProgressV2.totalCount);
    }
}

/**
 * Checks if picking is complete ( Not For ARv2 )
 * @param route
 * @param capability
 * @return {boolean|*}
 */
export function isPickingComplete(route) {
    return (route.routeStatus && !NOT_PICKED_STATUS_LIST.includes(route.routeStatus))
        || (route.pickProgressV2 && route.pickProgressV2.totalCount > 0 && route.pickProgressV2.completedCount === route.pickProgressV2.totalCount)
}

/**
 * Returns stage status indicator color
 *
 * @param stage status of route
 * @returns color
 */
export function getStageStatusColor(stageStatus) {
    switch (stageStatus) {
        case STAGE_STATUS.SIDELINED:
            return "error"
        case STAGE_STATUS.STAGED:
            return "success";
        case STAGE_STATUS.PRE_STAGED:
        case STAGE_STATUS.PARTIALLY_STAGED:
        case STAGE_STATUS.READY:
        case INTERIM_STAGED:
            return "warning";
        default:
            return "neutral";
    }
}

/**
 * Returns depart status
 *
 * @param route status returned by RSWS
 * @returns depart status
 */
export function getDepartStatus(rswsRoute, capability) {
    if(isNotINRegionOrSSD(capability)) {
        switch (rswsRoute.routeStatus) {
            case DEPARTED:
                return DEPART_STATUS.DEPARTED;
            case PARTIALLY_DEPARTED:
                return DEPART_STATUS.PARTIALLY_DEPARTED;
            case STAGED:
            case PARTIALLY_STAGED:
                return DEPART_STATUS.READY;
            case READY:
                return DEPART_STATUS.READY;
            default:
                return DEPART_STATUS.NOT_READY;
        }
    }
    return getDepartStatusForIN(rswsRoute);
}

export function getDepartStatusForIN(rswsRoute) {
    switch (rswsRoute.routeStatus) {
        case ASSIGNABLE:
            return DEPART_STATUS_IN.NOT_READY;
        case STOWED:
           return DEPART_STATUS_IN.READY;
        case  STOW_IN_PROGRESS:
            return DEPART_STATUS_IN.NOT_READY;
        case DEPARTED:
            return DEPART_STATUS_IN.DEPARTED;
        case CANCELLED:
            return DEPART_STATUS_IN.ROUTE_CANCELLED;
            default:
            return DEPART_STATUS.NOT_READY;
    }
}


/**
 * Returns depart status indicator color
 *
 * @param depart status of route
 * @returns color
 */
export function getDepartStatusColor(departStatus) {
    switch (departStatus) {
        case DEPART_STATUS.DEPARTED:
            return "success";
        case DEPART_STATUS.PARTIALLY_DEPARTED:
        case DEPART_STATUS.READY:
            return "warning";
        default:
            return "neutral";
    }
}

/**
 * Returns cart status
 *
 * @param route status returned by RSWS
 * @param cart object created from stow and RSWS response.
 * @param capability - station capability
 * @param stationConfig - station config
 * @returns parsed status
 */
export function getCartStatus(route, cart, capability, stationConfig) {
    if (capability === AR_V2) {
        if (route.sidelined && cart.status !== "STAGED") {
            return SIDELINED;
        } else if (cart.status === "MISSED") {
            return MISSING;
        } else if (cart.status === "STAGED") {
            return STAGED;
        } else if (cart.isStowed || cart.status === "READY") {
            return READY;
        } else {
            return NOT_READY;
        }
    } else if (stationConfig.splitStagingEnabled) {
        if ((route.sidelined && cart.status !== "STAGED") || cart.status === "SIDELINED") {
            return SIDELINED;
        } else if (cart.status === "MISSED") {
            return MISSING;
        } else if (cart.status === "STAGED" || cart.stageTime) {
            return STAGED;
        } else if (cart.preStageLocation) {
            return PRE_STAGED;
        } else {
            return NOT_READY;
        }
    } else {
        if ((route.sidelined && cart.status !== "STAGED") || cart.status === "SIDELINED") {
            return SIDELINED;
        } else if (cart.status === "STAGED" || cart.stageTime) {
            return STAGED;
        } else {
            return PRE_STAGED;
        }
    }
}

export function getStageStatusList(viewType, stationConfig) {
    let statusList = Object.values(STAGE_STATUS);
    if(stationConfig.ssdmmotenabled) {
        statusList.push(INTERIM_STAGED)
    }
    if (stationConfig.pickStageDecoupleEnabled && viewType === ROUTE_VIEW) {
        return statusList.filter(status => status !== READY);
    } else if (stationConfig.splitStagingEnabled) {
        return statusList;
    } else if (!stationConfig.pickStageDecoupleEnabled) {
        return statusList.filter(status => status !== PRE_STAGED);
    } else {
        return Object.values(CART_STATUS);
    }
}

export function getDepartStatusList(capability) {
    if(isNotINRegionOrSSD(capability)) {
        return Object.values(DEPART_STATUS);
    }
    return Object.values(DEPART_STATUS_IN);
}

export function getShipmentTypeList() {
    return Object.values(SHIPMENT_TYPE_AMXL);
}

/**
 * Returns cart status indicator color
 *
 * @param status of cart
 * @returns color
 */
export function getCartStatusColor(cartStatus) {
    switch (cartStatus) {
        case SIDELINED:
            return "error";
        case MISSING:
            return "error";
        case STAGED:
            return "success";
        case READY:
            return "warning";
        case PRE_STAGED:
            return "warning";
        default:
            return "neutral";
    }
}

/**
 * Updates route status to assignable if route is unassigned
 *
 * @param capability
 * @param routes
 * @returns updated routes
 */
export function handleUnassignedRoutes(capability, routes) {
    if (capability === CORE_AMZL) {
        routes.forEach(route => {
            if (route.routeStatus === IN_PROGRESS && !route.activeAssignee) {
                route.routeStatus = ASSIGNABLE;
            }
            //Note: picking duration needs to handled if required in stage/depart tab.
        });
    }
    return routes;
}


// WEBPACK FOOTER //
// ./src/components/util/EntityStatusManager.js